import {useCallback, useMemo} from 'react';
import {DEFAULT_TOAST_DURATION} from '@shopify/polaris';
import {ToastDescription} from 'utilities/toasts';
import {useAppBridge} from '@shopify/app-bridge-react';

export function useToastManager() {
  const appBridge = useAppBridge();
  const show = useCallback(
    ({error, content, duration = DEFAULT_TOAST_DURATION}: ToastDescription) => {
      appBridge.toast.show(content, {
        isError: error,
        duration,
      });
    },
    [appBridge.toast],
  );

  return useMemo(
    () => ({
      show,
    }),
    [show],
  );
}
